import http from '../http';
import {
  feedMappingsURLConstruct,
  errorPayload,
  formatArrayQueries,
  successPayload,
} from '../formatter';

const dataParamsContruct = () => ({
  // isReadAfterWrite: data.isReadAfterWrite || false,
  // search: data.searchParameter,
});

const getTableData = async (filters, tenantUuid = null) => {
  const baseURL = feedMappingsURLConstruct(tenantUuid);
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/feed-events/grid?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getEventSuggestions = async (tournamentId) => {
  const baseURL = feedMappingsURLConstruct();

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/core-tournaments/${tournamentId}/events`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const mapNewEntity = async (data) => {
  const baseURL = feedMappingsURLConstruct();
  try {
    const response = await http({
      method: 'POST',
      url: `${baseURL}/map`,
      data,
    });

    return successPayload(response);
  } catch (error) {
    console.log(error);
    return errorPayload(error);
  }
};

const unmapEntity = async (data) => {
  const baseURL = feedMappingsURLConstruct();
  try {
    const response = await http({
      method: 'POST',
      url: `${baseURL}/unmap`,
      data,
    });

    return successPayload(response);
  } catch (error) {
    console.log(error);
    return errorPayload(error);
  }
};

const getFeedTypesFilters = async () => {
  const baseURL = feedMappingsURLConstruct();

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/filters`,
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getSportsFilter = async (filters) => {
  const baseURL = feedMappingsURLConstruct();
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/feed-sports?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getCategories = async (filters) => {
  const baseURL = feedMappingsURLConstruct();
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/feed-categories?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

const getTournaments = async (filters) => {
  const baseURL = feedMappingsURLConstruct();
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/feed-tournaments?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};
/**
 *
 * @param {*} filters
 * @param {*} entity - core-events, core-sports, core-categories, core-tournaments, core-players
 * @returns
 */
const searchCoreEntities = async (filters, entity) => {
  const baseURL = feedMappingsURLConstruct();
  const queries = formatArrayQueries(filters);

  try {
    const response = await http({
      method: 'GET',
      url: `${baseURL}/${entity}?${queries}`,
      params: dataParamsContruct(filters),
    });

    return successPayload(response);
  } catch (error) {
    return errorPayload(error);
  }
};

export {
  getTableData,
  getEventSuggestions,
  getFeedTypesFilters,
  getCategories,
  getSportsFilter,
  getTournaments,
  mapNewEntity,
  unmapEntity,
  searchCoreEntities,
};
